import React from "react";
import AuthService from "./authService.js";

class JobTitleService extends React.Component {
  static GetJobTitleList() {
    const authService = AuthService.getInstance();

    const url = "/api/OfficialJobTitle";

    return authService.CallBackendFunction(url);
  }

  static GetUserOfficialJobTitleId() {
    const authService = AuthService.getInstance();

    const user = authService.GetLoggedInUser();
    return user.officialJobTitleId;
  }
}

export default JobTitleService;
